module.exports = __webpack_public_path__ + "assets/img/travel-day7.7ef1edc6.png";